import {
  convertHtmlToMarkdown,
  convertMarkdownToHtml,
} from '@wajeez-web/core/utils';

import { TextEditor } from './TextEditor';
import { TextEditorType } from '../types';

export const TextEditorMD = ({ value, onChange, ...props }: TextEditorType) => {
  return (
    <TextEditor
      value={convertMarkdownToHtml(value || '')}
      onChange={(value) => {
        onChange && onChange(convertHtmlToMarkdown(value || '') || '');
      }}
      {...props}
    />
  );
};
